import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import { FloatingExpertButton } from "@/components/FloatingExpertButton";
import { GoogleAnalytics } from "@/components/GoogleAnalytics";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Builder from "@/pages/Builder";
import Experts from "@/pages/Experts";
import Admin from "@/pages/Admin";
import ExpertPortal from "@/pages/ExpertPortal";
import Jobs from "@/pages/Jobs";
import ImproveResume from "@/pages/ImproveResume";
import AtsScore from "@/pages/AtsScore";
import Recruiters from "@/pages/Recruiters";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <GoogleAnalytics />
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/builder/:id" element={<Builder />} />
        <Route path="/experts" element={<Experts />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/improve" element={<ImproveResume />} />
        <Route path="/ats-score" element={<AtsScore />} />
        <Route path="/recruiters" element={<Recruiters />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/expert" element={<ExpertPortal />} />
      </Routes>
      <FloatingExpertButton />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
